import { Menu, Portal } from '@chakra-ui/react'
import type { FC } from 'react'
import { memo } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@app/components/ui/button'
import CardSection from '@app/shared/cards/components/cardSection'
import type { CardSize } from '@app/types'
import ICON_MAP from '@app/utils/iconMap'

interface Props {
  id: string
  size: CardSize
}

const CardMetricSourceCTA: FC<Props> = ({ id, size, ...rest }) => (
  <CardSection size={size} bgColor={{ base: 'yellow.100', _dark: 'bg.panel' }}>
    <Menu.Root>
      <Menu.Trigger asChild>
        <Button w="full" {...rest} variant="solid" colorPalette="yellow" fontWeight="bold">
          <ICON_MAP.DataSource />
          Connect data
        </Button>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            <Menu.Item value="a" asChild>
              <Link to={`metric/${id}/source`}>Connect data source</Link>
            </Menu.Item>
            <Menu.Item value="b">
              <Link to={`metric/${id}/data`}>Upload CSV</Link>
            </Menu.Item>
            <Menu.Item value="c" asChild>
              <Link to={`metric/${id}/source`} state={{ sourceName: 'MetricSources::DummyData' }}>
                Random data
              </Link>
            </Menu.Item>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  </CardSection>
)

export default memo(CardMetricSourceCTA)
